/**
 * Skid Steer Store — Compatibility Checker Engine
 * Asset file: assets/machines.js
 *
 * Upload to: Settings → Files  (or theme assets/)
 * Loaded by: snippets/compatibility-checker-widget.liquid
 *
 * Entry point: initCompatWidget(productDescriptionHTML)
 */

/* ══════════════════════════════════════════════════════════
   MACHINE DATABASE
   flowMin / flowMax = standard flow (GPM)
   hfFlowMin / hfFlowMax = high-flow kit (null if n/a)
   psiMax = max hydraulic pressure
   capacity = rated operating capacity (lbs)
   coupler = quick-attach type
   Tractors use: auxFlowMin/auxFlowMax, engineHP, ptoHP
   ══════════════════════════════════════════════════════════ */
var MACHINES = {

  // ═══════════════════════════════════════════════════════
  //  SKID STEERS
  // ═══════════════════════════════════════════════════════
  "skid-steer": {
    supportsHighFlow: true,
    makes: {

      "Bobcat": {
        "S70":   { flowMin:8.9, flowMax:8.9, hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:700,   coupler:"Bob-Tach", note:"Micro skid steer (22.5 hp). No high-flow option." },
        "S100":  { flowMin:12.0,flowMax:12.0,hfFlowMin:null, hfFlowMax:null, psiMax:2750, capacity:780,   coupler:"Bob-Tach", note:"No high-flow option on this model." },
        "S450":  { flowMin:16.7,flowMax:16.7,hfFlowMin:null, hfFlowMax:null, psiMax:3550, capacity:1340,  coupler:"Bob-Tach", note:"No high-flow option on this model." },
        "S510":  { flowMin:17.1,flowMax:17.1,hfFlowMin:null, hfFlowMax:null, psiMax:3550, capacity:1650,  coupler:"Bob-Tach", note:"No high-flow option on this model." },
        "S530":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:1850,  coupler:"Bob-Tach" },
        "S550":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:1900,  coupler:"Bob-Tach" },
        "S570":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:1950,  coupler:"Bob-Tach" },
        "S590":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:2100,  coupler:"Bob-Tach" },
        "S595":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:2200,  coupler:"Bob-Tach" },
        "S66":   { flowMin:17.6,flowMax:17.6,hfFlowMin:26.9, hfFlowMax:26.9, psiMax:3550, capacity:2400,  coupler:"Bob-Tach" },
        "S630":  { flowMin:23.0,flowMax:23.0,hfFlowMin:null, hfFlowMax:null, psiMax:3550, capacity:2180,  coupler:"Bob-Tach", note:"No high-flow option on this model." },
        "S650":  { flowMin:20.5,flowMax:20.5,hfFlowMin:25.5, hfFlowMax:25.5, psiMax:3550, capacity:2690,  coupler:"Bob-Tach" },
        "S74":   { flowMin:23.3,flowMax:23.3,hfFlowMin:30.3, hfFlowMax:30.3, psiMax:3550, capacity:2700,  coupler:"Bob-Tach" },
        "S76":   { flowMin:23.3,flowMax:23.3,hfFlowMin:30.3, hfFlowMax:30.3, psiMax:3550, capacity:2900,  coupler:"Bob-Tach" },
        "S86":   { flowMin:23.3,flowMax:23.3,hfFlowMin:30.3, hfFlowMax:30.3, psiMax:3550, capacity:3100,  coupler:"Bob-Tach" },
        "S740":  { flowMin:23.0,flowMax:23.0,hfFlowMin:30.3, hfFlowMax:30.3, psiMax:3550, capacity:3200,  coupler:"Bob-Tach" },
        "S750":  { flowMin:23.0,flowMax:23.0,hfFlowMin:36.5, hfFlowMax:36.5, psiMax:3550, capacity:3200,  coupler:"Bob-Tach" },
        "S770":  { flowMin:23.3,flowMax:23.3,hfFlowMin:30.3, hfFlowMax:30.3, psiMax:3550, capacity:3350,  coupler:"Bob-Tach" },
        "S850":  { flowMin:23.0,flowMax:23.0,hfFlowMin:36.5, hfFlowMax:36.5, psiMax:3550, capacity:3950,  coupler:"Bob-Tach" },
        "T450":  { flowMin:16.7,flowMax:16.7,hfFlowMin:null, hfFlowMax:null, psiMax:3550, capacity:1300,  coupler:"Bob-Tach", note:"No high-flow option on this model." },
        "T550":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:1900,  coupler:"Bob-Tach" },
        "T590":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:2100,  coupler:"Bob-Tach" },
        "T595":  { flowMin:17.1,flowMax:17.1,hfFlowMin:26.7, hfFlowMax:26.7, psiMax:3550, capacity:2200,  coupler:"Bob-Tach" },
        "T630":  { flowMin:23.0,flowMax:23.0,hfFlowMin:null, hfFlowMax:null, psiMax:3550, capacity:2180,  coupler:"Bob-Tach", note:"No high-flow option on this model." },
        "T650":  { flowMin:20.5,flowMax:20.5,hfFlowMin:25.5, hfFlowMax:25.5, psiMax:3550, capacity:2690,  coupler:"Bob-Tach" },
        "T740":  { flowMin:23.0,flowMax:23.0,hfFlowMin:30.3, hfFlowMax:30.3, psiMax:3550, capacity:3200,  coupler:"Bob-Tach" },
        "T750":  { flowMin:23.0,flowMax:23.0,hfFlowMin:36.5, hfFlowMax:36.5, psiMax:3550, capacity:3200,  coupler:"Bob-Tach" },
        "T770":  { flowMin:23.3,flowMax:23.3,hfFlowMin:30.3, hfFlowMax:30.3, psiMax:3550, capacity:2900,  coupler:"Bob-Tach" },
        "T870":  { flowMin:23.0,flowMax:23.0,hfFlowMin:36.5, hfFlowMax:36.5, psiMax:3550, capacity:3750,  coupler:"Bob-Tach" },
        "S130":  { flowMin:12.0,flowMax:12.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1300,  coupler:"Bob-Tach", note:"Legacy model. No high-flow option." },
        "S150":  { flowMin:14.0,flowMax:14.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1500,  coupler:"Bob-Tach", note:"Legacy model. No high-flow option." },
        "S160":  { flowMin:14.0,flowMax:14.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1600,  coupler:"Bob-Tach", note:"Legacy model. No high-flow option." },
        "S175":  { flowMin:16.3,flowMax:16.3,hfFlowMin:null, hfFlowMax:null, psiMax:3350, capacity:1750,  coupler:"Bob-Tach", note:"Legacy model. No high-flow option." },
        "S185":  { flowMin:16.3,flowMax:16.3,hfFlowMin:null, hfFlowMax:null, psiMax:3350, capacity:1850,  coupler:"Bob-Tach", note:"Legacy model. No high-flow option." },
        "S205":  { flowMin:16.3,flowMax:16.3,hfFlowMin:25.5, hfFlowMax:25.5, psiMax:3350, capacity:2050,  coupler:"Bob-Tach" },
        "S220":  { flowMin:18.0,flowMax:18.0,hfFlowMin:null, hfFlowMax:null, psiMax:3350, capacity:2200,  coupler:"Bob-Tach", note:"Legacy model. No high-flow option." },
        "S250":  { flowMin:20.6,flowMax:20.6,hfFlowMin:30.6, hfFlowMax:30.6, psiMax:3350, capacity:2640,  coupler:"Bob-Tach" },
        "S300":  { flowMin:23.0,flowMax:23.0,hfFlowMin:36.5, hfFlowMax:36.5, psiMax:3350, capacity:3000,  coupler:"Bob-Tach" },
        "S330":  { flowMin:23.0,flowMax:23.0,hfFlowMin:36.5, hfFlowMax:36.5, psiMax:3550, capacity:3350,  coupler:"Bob-Tach" }
      },

      "Caterpillar": {
        "226D3":    { flowMin:20, flowMax:21, hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1450,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "232D3":    { flowMin:20, flowMax:22, hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1750,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "236D3":    { flowMin:22, flowMax:24, hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2000,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "242D3":    { flowMin:22, flowMax:24, hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2200,  coupler:"Cat IT",                    note:"No high-flow option on this model." },
        "246D3":    { flowMin:22, flowMax:23, hfFlowMin:32,   hfFlowMax:32,   psiMax:3190, capacity:2200,  coupler:"Cat IT" },
        "262D3":    { flowMin:22, flowMax:23, hfFlowMin:32,   hfFlowMax:32,   psiMax:3335, capacity:2700,  coupler:"Cat IT" },
        "272D3":    { flowMin:22, flowMax:23, hfFlowMin:32,   hfFlowMax:32,   psiMax:3335, capacity:3000,  coupler:"Cat IT" },
        "272D3 XE": { flowMin:22, flowMax:23, hfFlowMin:40,   hfFlowMax:40,   psiMax:4060, capacity:3200,  coupler:"Cat IT", note:"XE = Extreme High Flow. 40 GPM @ 4060 PSI." },
        "226D":     { flowMin:18, flowMax:21, hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1350,  coupler:"Universal Skid Steer (SSL)", note:"Legacy model. No high-flow option." },
        "236D":     { flowMin:21, flowMax:23, hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1800,  coupler:"Universal Skid Steer (SSL)", note:"Legacy model. No high-flow option." },
        "242D":     { flowMin:21, flowMax:23, hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2000,  coupler:"Cat IT",                    note:"Legacy model. No high-flow option." },
        "246D":     { flowMin:22, flowMax:23, hfFlowMin:32,   hfFlowMax:32,   psiMax:3336, capacity:2150,  coupler:"Cat IT" },
        "262D":     { flowMin:22, flowMax:23, hfFlowMin:32,   hfFlowMax:32,   psiMax:3336, capacity:2700,  coupler:"Cat IT" },
        "272D":     { flowMin:22, flowMax:23, hfFlowMin:32,   hfFlowMax:32,   psiMax:3336, capacity:2900,  coupler:"Cat IT" },
        "272D XHP": { flowMin:22, flowMax:23, hfFlowMin:40,   hfFlowMax:40,   psiMax:4060, capacity:3000,  coupler:"Cat IT", note:"XHP = Extreme High Performance. 40 GPM @ 4060 PSI." }
      },

      "John Deere": {
        "312G P-Tier":  { flowMin:13.2,flowMax:13.2,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1100,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "314G P-Tier":  { flowMin:13.2,flowMax:13.2,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1260,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "316GR P-Tier": { flowMin:13.2,flowMax:13.2,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1600,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "318G P-Tier":  { flowMin:15.5,flowMax:15.5,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1750,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "320G P-Tier":  { flowMin:19.8,flowMax:19.8,hfFlowMin:26.9, hfFlowMax:26.9, psiMax:3190, capacity:2000,  coupler:"Deere Quik-Tatch" },
        "324G P-Tier":  { flowMin:21.2,flowMax:21.2,hfFlowMin:26.9, hfFlowMax:26.9, psiMax:3190, capacity:2400,  coupler:"Deere Quik-Tatch" },
        "330G P-Tier":  { flowMin:24.0,flowMax:24.0,hfFlowMin:32.0, hfFlowMax:32.0, psiMax:3480, capacity:3000,  coupler:"Deere Quik-Tatch" },
        "332G P-Tier":  { flowMin:24.0,flowMax:24.0,hfFlowMin:38.0, hfFlowMax:38.0, psiMax:3625, capacity:3325,  coupler:"Deere Quik-Tatch" },
        "312GR":  { flowMin:13.2,flowMax:13.2,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1100,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "314G":   { flowMin:13.2,flowMax:13.2,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1260,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "316GR":  { flowMin:13.2,flowMax:13.2,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1600,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "317G":   { flowMin:13.2,flowMax:13.2,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1575,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "318G":   { flowMin:15.5,flowMax:15.5,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1750,  coupler:"Deere Quik-Tatch", note:"No high-flow option on this model." },
        "320G":   { flowMin:19.8,flowMax:19.8,hfFlowMin:26.9, hfFlowMax:26.9, psiMax:3190, capacity:2000,  coupler:"Deere Quik-Tatch" },
        "324G":   { flowMin:21.2,flowMax:21.2,hfFlowMin:26.9, hfFlowMax:26.9, psiMax:3190, capacity:2400,  coupler:"Deere Quik-Tatch" },
        "326G":   { flowMin:21.2,flowMax:21.2,hfFlowMin:26.9, hfFlowMax:26.9, psiMax:3190, capacity:2500,  coupler:"Deere Quik-Tatch" },
        "328G":   { flowMin:24.0,flowMax:24.0,hfFlowMin:32.0, hfFlowMax:32.0, psiMax:3480, capacity:2750,  coupler:"Deere Quik-Tatch" },
        "330G":   { flowMin:24.0,flowMax:24.0,hfFlowMin:32.0, hfFlowMax:32.0, psiMax:3480, capacity:3000,  coupler:"Deere Quik-Tatch" },
        "331G":   { flowMin:24.0,flowMax:24.0,hfFlowMin:32.0, hfFlowMax:32.0, psiMax:3480, capacity:3175,  coupler:"Deere Quik-Tatch" },
        "332G":   { flowMin:24.0,flowMax:24.0,hfFlowMin:38.0, hfFlowMax:38.0, psiMax:3625, capacity:3325,  coupler:"Deere Quik-Tatch" },
        "333G":   { flowMin:24.0,flowMax:24.0,hfFlowMin:38.0, hfFlowMax:38.0, psiMax:3625, capacity:3325,  coupler:"Deere Quik-Tatch" },
        "317D":   { flowMin:13.0,flowMax:13.0,hfFlowMin:null, hfFlowMax:null, psiMax:2900, capacity:1500,  coupler:"Deere Quik-Tatch", note:"Legacy model. No high-flow option." },
        "320D":   { flowMin:18.8,flowMax:18.8,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1900,  coupler:"Deere Quik-Tatch", note:"Legacy model. No high-flow option." },
        "323D":   { flowMin:18.8,flowMax:18.8,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2300,  coupler:"Deere Quik-Tatch", note:"Legacy model. No high-flow option." },
        "326D":   { flowMin:21.2,flowMax:21.2,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2300,  coupler:"Deere Quik-Tatch", note:"Legacy model. No high-flow option." },
        "328D":   { flowMin:24.0,flowMax:24.0,hfFlowMin:32.0, hfFlowMax:32.0, psiMax:3480, capacity:2750,  coupler:"Deere Quik-Tatch" },
        "329D":   { flowMin:24.0,flowMax:24.0,hfFlowMin:32.0, hfFlowMax:32.0, psiMax:3480, capacity:2900,  coupler:"Deere Quik-Tatch" },
        "332D":   { flowMin:24.0,flowMax:24.0,hfFlowMin:38.0, hfFlowMax:38.0, psiMax:3625, capacity:3175,  coupler:"Deere Quik-Tatch" },
        "333D":   { flowMin:24.0,flowMax:24.0,hfFlowMin:38.0, hfFlowMax:38.0, psiMax:3625, capacity:3325,  coupler:"Deere Quik-Tatch" }
      },

      "Case": {
        "SR130":  { flowMin:16.0,flowMax:16.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1300,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "SR150":  { flowMin:16.0,flowMax:16.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1500,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "SR175":  { flowMin:20.6,flowMax:20.6,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:1750,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "SV185":  { flowMin:20.6,flowMax:20.6,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:1850,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "SR200":  { flowMin:24.2,flowMax:24.2,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:2000,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "SR210":  { flowMin:24.2,flowMax:24.2,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:2100,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "SR220":  { flowMin:24.0,flowMax:24.0,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2200,  coupler:"Universal Skid Steer (SSL)" },
        "SR240":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2400,  coupler:"Universal Skid Steer (SSL)" },
        "SR250":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2500,  coupler:"Universal Skid Steer (SSL)" },
        "SR270":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3200, capacity:2700,  coupler:"Universal Skid Steer (SSL)" },
        "SV250":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2500,  coupler:"Universal Skid Steer (SSL)" },
        "SV280":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2800,  coupler:"Universal Skid Steer (SSL)" },
        "SV300":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3200, capacity:3000,  coupler:"Universal Skid Steer (SSL)" },
        "SV340":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3200, capacity:3400,  coupler:"Universal Skid Steer (SSL)" },
        "TR270":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3200, capacity:2700,  coupler:"Universal Skid Steer (SSL)" },
        "TR310":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3200, capacity:3100,  coupler:"Universal Skid Steer (SSL)" },
        "TR320":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3200, capacity:3200,  coupler:"Universal Skid Steer (SSL)" },
        "TV380":  { flowMin:24.2,flowMax:24.2,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3200, capacity:3800,  coupler:"Universal Skid Steer (SSL)" }
      },

      "New Holland": {
        "L213":   { flowMin:18.5,flowMax:18.5,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1300,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "L216":   { flowMin:18.5,flowMax:18.5,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1600,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "L221":   { flowMin:20.3,flowMax:20.3,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2100,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "L218":   { flowMin:30.8,flowMax:30.8,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1800,  coupler:"Universal Skid Steer (SSL)", note:"NH L218 standard flow is already 30.8 GPM." },
        "L220":   { flowMin:29.8,flowMax:29.8,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2000,  coupler:"Universal Skid Steer (SSL)", note:"NH L220 standard flow is already 29.8 GPM." },
        "L223":   { flowMin:29.8,flowMax:29.8,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2300,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "L225":   { flowMin:29.8,flowMax:29.8,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2500,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "L228":   { flowMin:32.3,flowMax:32.3,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2800,  coupler:"Universal Skid Steer (SSL)", note:"NH L228 standard flow is already 32.3 GPM." },
        "L230":   { flowMin:30.7,flowMax:30.7,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:3000,  coupler:"Universal Skid Steer (SSL)", note:"NH L230 standard flow is already 30.7 GPM." },
        "L234":   { flowMin:30.7,flowMax:30.7,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:3400,  coupler:"Universal Skid Steer (SSL)", note:"NH L234 standard flow is already 30.7 GPM." }
      },

      "Kubota": {
        "SSV65":  { flowMin:18.0,flowMax:18.0,hfFlowMin:28.0, hfFlowMax:28.0, psiMax:3188, capacity:1950,  coupler:"Universal Skid Steer (SSL)" },
        "SSV75":  { flowMin:20.9,flowMax:20.9,hfFlowMin:30.4, hfFlowMax:30.4, psiMax:3188, capacity:2690,  coupler:"Universal Skid Steer (SSL)" }
      },

      "Gehl": {
        "R105":       { flowMin:14.5,flowMax:14.5,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:1050,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "R135 GEN:2": { flowMin:16.8,flowMax:16.8,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:1350,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "R165":       { flowMin:20.4,flowMax:20.4,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:1650,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "R190":       { flowMin:18.5,flowMax:18.5,hfFlowMin:null, hfFlowMax:null, psiMax:3050, capacity:1900,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "R220":       { flowMin:23.5,flowMax:23.5,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2200,  coupler:"Universal Skid Steer (SSL)" },
        "R260":       { flowMin:23.5,flowMax:23.5,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2600,  coupler:"Universal Skid Steer (SSL)" },
        "V270 GEN:2": { flowMin:23.5,flowMax:23.5,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:2700,  coupler:"Universal Skid Steer (SSL)" },
        "V330 GEN:2": { flowMin:23.5,flowMax:23.5,hfFlowMin:37.0, hfFlowMax:37.0, psiMax:3050, capacity:3300,  coupler:"Universal Skid Steer (SSL)" },
        "V420":       { flowMin:30.1,flowMax:30.1,hfFlowMin:null, hfFlowMax:null, psiMax:3480, capacity:4200,  coupler:"Universal Skid Steer (SSL)", note:"V420 standard flow is already 30 GPM." }
      },

      "ASV": {
        "VT-70":    { flowMin:14.0,flowMax:14.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1500,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "VT-100":   { flowMin:19.0,flowMax:19.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:2100,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "RT-40":    { flowMin:11.5,flowMax:11.5,hfFlowMin:null, hfFlowMax:null, psiMax:2600, capacity:850,   coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "RT-50":    { flowMin:14.5,flowMax:14.5,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1100,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "RT-65":    { flowMin:17.0,flowMax:17.0,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1500,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "RT-75":    { flowMin:18.5,flowMax:18.5,hfFlowMin:null, hfFlowMax:null, psiMax:3000, capacity:1700,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "RT-75 HF": { flowMin:18.5,flowMax:18.5,hfFlowMin:27.0, hfFlowMax:27.0,psiMax:3200, capacity:1700,  coupler:"Universal Skid Steer (SSL)" },
        "RT-110":   { flowMin:21.0,flowMax:21.0,hfFlowMin:33.5, hfFlowMax:33.5, psiMax:3200, capacity:2500,  coupler:"Universal Skid Steer (SSL)" },
        "RT-120":   { flowMin:22.0,flowMax:22.0,hfFlowMin:34.5, hfFlowMax:34.5, psiMax:3200, capacity:2800,  coupler:"Universal Skid Steer (SSL)" },
        "RT-135":   { flowMin:22.0,flowMax:22.0,hfFlowMin:34.5, hfFlowMax:34.5, psiMax:3200, capacity:3000,  coupler:"Universal Skid Steer (SSL)" },
        "RT-135 F": { flowMin:22.0,flowMax:22.0,hfFlowMin:34.5, hfFlowMax:34.5, psiMax:3200, capacity:3000,  coupler:"Universal Skid Steer (SSL)" }
      },

      "Manitou": {
        "1050 R":     { flowMin:16.0,flowMax:16.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1050,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "1650 R":     { flowMin:20.0,flowMax:20.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1650,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "2050 R ST5": { flowMin:22.0,flowMax:22.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2050,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "2150 R ST5": { flowMin:22.0,flowMax:22.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2150,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "2500 R ST5": { flowMin:24.0,flowMax:24.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2500,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "3300 V":     { flowMin:26.0,flowMax:26.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:3300,  coupler:"Universal Skid Steer (SSL)", note:"Vertical-lift. No high-flow option." }
      },

      "Takeuchi": {
        "TL6R":   { flowMin:18.0,flowMax:18.0,hfFlowMin:null, hfFlowMax:null, psiMax:3200, capacity:1760,  coupler:"Universal Skid Steer (SSL)", note:"Compact track loader. No high-flow." },
        "TL8":    { flowMin:22.0,flowMax:22.0,hfFlowMin:null, hfFlowMax:null, psiMax:3200, capacity:2149,  coupler:"Universal Skid Steer (SSL)", note:"Compact track loader. No high-flow." },
        "TL10":   { flowMin:25.0,flowMax:25.0,hfFlowMin:null, hfFlowMax:null, psiMax:3200, capacity:2600,  coupler:"Universal Skid Steer (SSL)", note:"Compact track loader. No high-flow." },
        "TL12":   { flowMin:27.0,flowMax:27.0,hfFlowMin:null, hfFlowMax:null, psiMax:3200, capacity:3000,  coupler:"Universal Skid Steer (SSL)", note:"Compact track loader. No high-flow." },
        "TL12R2": { flowMin:27.0,flowMax:27.0,hfFlowMin:null, hfFlowMax:null, psiMax:3200, capacity:3000,  coupler:"Universal Skid Steer (SSL)", note:"Compact track loader. No high-flow." }
      },

      "Yanmar": {
        "V8":    { flowMin:18.0,flowMax:18.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:1700,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "V10":   { flowMin:20.0,flowMax:20.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2000,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." },
        "SV100": { flowMin:22.0,flowMax:22.0,hfFlowMin:null, hfFlowMax:null, psiMax:3190, capacity:2200,  coupler:"Universal Skid Steer (SSL)", note:"No high-flow option on this model." }
      },

      "Wacker Neuson": {
        "SW16": { flowMin:15,flowMax:16,hfFlowMin:null,hfFlowMax:null,psiMax:3045,capacity:1600,coupler:"Universal Skid Steer (SSL)",note:"Wheeled SSL. No high-flow." },
        "SW21": { flowMin:19,flowMax:21,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2100,coupler:"Universal Skid Steer (SSL)",note:"Wheeled SSL. No high-flow." },
        "SW24": { flowMin:22,flowMax:24,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2400,coupler:"Universal Skid Steer (SSL)",note:"Wheeled SSL. No high-flow." },
        "SW28": { flowMin:25,flowMax:28,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2800,coupler:"Universal Skid Steer (SSL)",note:"Wheeled SSL. No high-flow." },
        "SW34": { flowMin:30,flowMax:34,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:3400,coupler:"Universal Skid Steer (SSL)",note:"Wheeled SSL. No high-flow." },
        "ST14": { flowMin:12,flowMax:14,hfFlowMin:null,hfFlowMax:null,psiMax:2900,capacity:1400,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "ST25": { flowMin:22,flowMax:25,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2500,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "ST31": { flowMin:26,flowMax:30,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:3100,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "ST35": { flowMin:29,flowMax:34,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:3500,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." }
      },

      "Doosan / Develon": {
        "SSL800":  { flowMin:16,flowMax:20,hfFlowMin:null,hfFlowMax:null,psiMax:3045,capacity:1815,coupler:"Universal Skid Steer (SSL)",note:"Wheeled SSL. Now branded Develon." },
        "SSL1000": { flowMin:20,flowMax:24,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2254,coupler:"Universal Skid Steer (SSL)",note:"Wheeled SSL. Now branded Develon." },
        "CTL55":   { flowMin:16,flowMax:20,hfFlowMin:26,hfFlowMax:30,psiMax:3190,capacity:1680,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader. Now branded Develon." },
        "CTL60":   { flowMin:18,flowMax:22,hfFlowMin:28,hfFlowMax:32,psiMax:3335,capacity:2094,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader. Now branded Develon." },
        "CTL80":   { flowMin:22,flowMax:26,hfFlowMin:30,hfFlowMax:36,psiMax:3335,capacity:2469,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader. Now branded Develon." },
        "CTL100":  { flowMin:25,flowMax:29,hfFlowMin:34,hfFlowMax:40,psiMax:3335,capacity:3175,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader. Now branded Develon." },
        "CTL120":  { flowMin:28,flowMax:33,hfFlowMin:38,hfFlowMax:44,psiMax:3625,capacity:3600,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader. Now branded Develon." }
      },

      "Mustang": {
        "1650R":  { flowMin:15,flowMax:17,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:1650,coupler:"Universal Skid Steer (SSL)" },
        "1750R":  { flowMin:17,flowMax:19,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:1750,coupler:"Universal Skid Steer (SSL)" },
        "2056R":  { flowMin:20,flowMax:23,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2056,coupler:"Universal Skid Steer (SSL)" },
        "2076R":  { flowMin:22,flowMax:25,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2076,coupler:"Universal Skid Steer (SSL)" },
        "2200RT": { flowMin:20,flowMax:22,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2200,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "2700V":  { flowMin:24,flowMax:27,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2700,coupler:"Universal Skid Steer (SSL)",note:"Vertical-lift." },
        "3200V":  { flowMin:28,flowMax:31,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:3200,coupler:"Universal Skid Steer (SSL)",note:"Vertical-lift." },
        "3300RT": { flowMin:28,flowMax:32,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:3300,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "3450RT": { flowMin:31,flowMax:35,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:3450,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." }
      },

      "Volvo CE": {
        "MC60C":   { flowMin:18,flowMax:21,hfFlowMin:null,hfFlowMax:null,psiMax:3188,capacity:1929,coupler:"Universal Skid Steer (SSL)",note:"Wheeled. No high-flow." },
        "MC80C":   { flowMin:22,flowMax:25,hfFlowMin:null,hfFlowMax:null,psiMax:3188,capacity:2395,coupler:"Universal Skid Steer (SSL)",note:"Wheeled. No high-flow." },
        "MC110C":  { flowMin:25,flowMax:29,hfFlowMin:null,hfFlowMax:null,psiMax:3408,capacity:2866,coupler:"Universal Skid Steer (SSL)",note:"Wheeled. No high-flow." },
        "MC135C":  { flowMin:29,flowMax:33,hfFlowMin:38,hfFlowMax:42,psiMax:3408,capacity:3329,coupler:"Universal Skid Steer (SSL)",note:"Wheeled. High-flow optional." },
        "MCT85C":  { flowMin:22,flowMax:25,hfFlowMin:null,hfFlowMax:null,psiMax:3188,capacity:2094,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "MCT110C": { flowMin:25,flowMax:29,hfFlowMin:null,hfFlowMax:null,psiMax:3408,capacity:2756,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "MCT125C": { flowMin:29,flowMax:33,hfFlowMin:38,hfFlowMax:42,psiMax:3408,capacity:3020,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader. High-flow optional." }
      },

      "Kobelco": {
        "SSL45W-3":  { flowMin:15,flowMax:17,hfFlowMin:null,hfFlowMax:null,psiMax:3045,capacity:990,coupler:"Universal Skid Steer (SSL)",note:"Wheeled compact." },
        "SSL65W-3":  { flowMin:18,flowMax:21,hfFlowMin:null,hfFlowMax:null,psiMax:3045,capacity:1480,coupler:"Universal Skid Steer (SSL)",note:"Wheeled." },
        "SSL90W-3":  { flowMin:22,flowMax:26,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:2000,coupler:"Universal Skid Steer (SSL)",note:"Wheeled." },
        "TL150S-7":  { flowMin:19,flowMax:22,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:1500,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "TL200S-7":  { flowMin:22,flowMax:26,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:2000,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "TL250S-7":  { flowMin:26,flowMax:30,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:2500,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." }
      },

      "JCB": {
        "215":  { flowMin:16,flowMax:19,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:1550,coupler:"Universal Skid Steer (SSL)" },
        "225":  { flowMin:18,flowMax:21,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:1650,coupler:"Universal Skid Steer (SSL)" },
        "245":  { flowMin:20,flowMax:23,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:1810,coupler:"Universal Skid Steer (SSL)" },
        "260":  { flowMin:23,flowMax:26,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:2238,coupler:"Universal Skid Steer (SSL)" },
        "270":  { flowMin:24,flowMax:28,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:2450,coupler:"Universal Skid Steer (SSL)" },
        "225T": { flowMin:18,flowMax:21,hfFlowMin:null,hfFlowMax:null,psiMax:3335,capacity:1650,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "260T": { flowMin:23,flowMax:26,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:2238,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." },
        "300T": { flowMin:27,flowMax:31,hfFlowMin:37,hfFlowMax:42,psiMax:3625,capacity:3000,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader. High-flow optional." },
        "320T": { flowMin:31,flowMax:35,hfFlowMin:null,hfFlowMax:null,psiMax:3625,capacity:3200,coupler:"Universal Skid Steer (SSL)",note:"Compact track loader." }
      }
    }
  },

  // ═══════════════════════════════════════════════════════
  //  MINI SKID STEERS
  // ═══════════════════════════════════════════════════════
  "mini-skid-steer": {
    supportsHighFlow: false,
    makes: {
      "Bobcat": {
        "MT52":  { flowMin:6.7, flowMax:6.7,  psiMax:2900, capacity:500,  coupler:"Mini SSL" },
        "MT55":  { flowMin:12.0,flowMax:12.0, psiMax:2900, capacity:650,  coupler:"Mini SSL" },
        "MT85":  { flowMin:12.0,flowMax:12.0, psiMax:2900, capacity:850,  coupler:"Mini SSL" },
        "MT100": { flowMin:12.0,flowMax:12.0, psiMax:2900, capacity:1200, coupler:"Mini SSL" }
      },
      "Toro / Dingo": {
        "TX 525 Narrow": { flowMin:5.5,flowMax:5.5,psiMax:2300,capacity:500,coupler:"Mini SSL" },
        "TX 525 Wide":   { flowMin:5.5,flowMax:5.5,psiMax:2300,capacity:525,coupler:"Mini SSL" },
        "TX 1000":       { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:1000,coupler:"Mini SSL" },
        "TX 1000 Narrow":{ flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:1000,coupler:"Mini SSL" },
        "TXL 2000":      { flowMin:14.0,flowMax:14.0,psiMax:3100,capacity:2000,coupler:"Mini SSL" }
      },
      "Vermeer": {
        "S450TX": { flowMin:6.8,flowMax:6.8,psiMax:2300,capacity:450,coupler:"Mini SSL" },
        "S550TX": { flowMin:9.0,flowMax:9.0,psiMax:2500,capacity:550,coupler:"Mini SSL" },
        "S800TX": { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:800,coupler:"Mini SSL" },
        "S925TX": { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:925,coupler:"Mini SSL" }
      },
      "Boxer": {
        "322D":   { flowMin:5.3,flowMax:5.3,psiMax:2000,capacity:450,coupler:"Mini SSL" },
        "425DX":  { flowMin:7.4,flowMax:7.4,psiMax:2300,capacity:600,coupler:"Mini SSL" },
        "532DX":  { flowMin:7.4,flowMax:7.4,psiMax:2300,capacity:650,coupler:"Mini SSL" },
        "600HD":  { flowMin:9.0,flowMax:9.0,psiMax:2500,capacity:600,coupler:"Mini SSL" },
        "700HDX": { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:700,coupler:"Mini SSL" },
        "850HD":  { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:850,coupler:"Mini SSL" }
      },
      "Ditch Witch": {
        "SK600":  { flowMin:7.0,flowMax:7.0,psiMax:2300,capacity:600,coupler:"Mini SSL" },
        "SK755":  { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:755,coupler:"Mini SSL" },
        "SK800":  { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:800,coupler:"Mini SSL" },
        "SK1550": { flowMin:14.0,flowMax:14.0,psiMax:3000,capacity:1550,coupler:"Mini SSL" },
        "SK3000": { flowMin:17.0,flowMax:17.0,psiMax:3200,capacity:3000,coupler:"Mini SSL" }
      },
      "ASV": {
        "RT-25": { flowMin:6.5,flowMax:6.5,psiMax:2600,capacity:500,coupler:"Mini SSL" },
        "RT-50": { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:750,coupler:"Mini SSL" }
      },
      "Kubota": {
        "SCL1000":   { flowMin:10.0,flowMax:11.0,psiMax:2640,capacity:1000,coupler:"Mini SSL",note:"Stand-on mini compact track loader." },
        "SCL1000-2": { flowMin:10.5,flowMax:11.3,psiMax:2640,capacity:1000,coupler:"Mini SSL",note:"Stand-on mini compact track loader. Updated hydraulics." }
      },
      "Caterpillar": {
        "247D3": { flowMin:9.5,flowMax:10.8,psiMax:2960,capacity:1075,coupler:"Universal Skid Steer (SSL)",note:"Mini compact track loader." },
        "257D3": { flowMin:10.5,flowMax:11.9,psiMax:2960,capacity:1025,coupler:"Universal Skid Steer (SSL)",note:"Mini compact track loader." },
        "259D3": { flowMin:10.5,flowMax:11.9,psiMax:2960,capacity:1200,coupler:"Universal Skid Steer (SSL)",note:"Mini compact track loader." },
        "279D3": { flowMin:12.5,flowMax:14.0,psiMax:3045,capacity:1500,coupler:"Universal Skid Steer (SSL)",note:"Mini compact track loader." },
        "289D3": { flowMin:14.0,flowMax:15.5,psiMax:3335,capacity:1900,coupler:"Universal Skid Steer (SSL)",note:"Mini compact track loader." }
      },
      "Wacker Neuson": {
        "ST14": { flowMin:11.0,flowMax:14.0,psiMax:2900,capacity:1400,coupler:"Mini SSL",note:"Stand-on tracked mini." },
        "ST25": { flowMin:16.0,flowMax:20.0,psiMax:3335,capacity:2500,coupler:"Mini SSL",note:"Stand-on tracked mini." },
        "SW16": { flowMin:7.5,flowMax:9.5,psiMax:2175,capacity:1190,coupler:"Mini SSL",note:"Walk-behind wheeled stand-on." }
      },
      "Barreto": {
        "1320SK": { flowMin:6.5,flowMax:7.5,psiMax:2500,capacity:700,coupler:"Mini SSL",note:"Walk-behind stand-on mini." },
        "2024SK": { flowMin:7.0,flowMax:8.5,psiMax:2500,capacity:800,coupler:"Mini SSL",note:"Ride-on stand-on mini." }
      }
    }
  },

  // ═══════════════════════════════════════════════════════
  //  EXCAVATORS (standard / large)
  // ═══════════════════════════════════════════════════════
  "excavator": {
    supportsHighFlow: false,
    makes: {
      "Caterpillar": {
        "308 CR": { flowMin:22,flowMax:28,psiMax:3550,capacity:18500,coupler:"CAT Pin-On" },
        "313":    { flowMin:25,flowMax:35,psiMax:3770,capacity:29100,coupler:"CAT Pin-On" },
        "315":    { flowMin:28,flowMax:38,psiMax:3770,capacity:33000,coupler:"CAT Pin-On" },
        "317":    { flowMin:30,flowMax:42,psiMax:4060,capacity:38600,coupler:"CAT Pin-On" },
        "320":    { flowMin:37,flowMax:55,psiMax:4500,capacity:46000,coupler:"CAT Pin-On" },
        "323":    { flowMin:40,flowMax:58,psiMax:4500,capacity:52000,coupler:"CAT Pin-On" },
        "325":    { flowMin:42,flowMax:63,psiMax:4800,capacity:60000,coupler:"CAT Pin-On" },
        "330":    { flowMin:45,flowMax:65,psiMax:4800,capacity:66000,coupler:"CAT Pin-On" },
        "336":    { flowMin:53,flowMax:79,psiMax:5076,capacity:82000,coupler:"CAT Pin-On" },
        "340":    { flowMin:58,flowMax:85,psiMax:5076,capacity:90000,coupler:"CAT Pin-On" },
        "349":    { flowMin:62,flowMax:90,psiMax:5076,capacity:107000,coupler:"CAT Pin-On" },
        "352":    { flowMin:66,flowMax:96,psiMax:5076,capacity:115000,coupler:"CAT Pin-On" },
        "374":    { flowMin:78,flowMax:115,psiMax:5076,capacity:171000,coupler:"CAT Pin-On" },
        "390":    { flowMin:90,flowMax:135,psiMax:5076,capacity:198000,coupler:"CAT Pin-On" }
      },
      "Komatsu": {
        "PC138US-11": { flowMin:26,flowMax:40,psiMax:4300,capacity:30000,coupler:"Pin-On" },
        "PC200-11":   { flowMin:37,flowMax:56,psiMax:4350,capacity:44000,coupler:"Pin-On" },
        "PC210LC-11": { flowMin:37,flowMax:58,psiMax:4350,capacity:47000,coupler:"Pin-On" },
        "PC240LC-11": { flowMin:42,flowMax:63,psiMax:4560,capacity:57000,coupler:"Pin-On" },
        "PC290LC-11": { flowMin:50,flowMax:74,psiMax:4700,capacity:67000,coupler:"Pin-On" },
        "PC360LC-11": { flowMin:63,flowMax:93,psiMax:5076,capacity:82000,coupler:"Pin-On" },
        "PC490LC-11": { flowMin:80,flowMax:118,psiMax:5076,capacity:108000,coupler:"Pin-On" }
      },
      "John Deere": {
        "130G":    { flowMin:22,flowMax:33,psiMax:4060,capacity:29000,coupler:"Pin-On" },
        "160G LC": { flowMin:30,flowMax:44,psiMax:4060,capacity:38000,coupler:"Pin-On" },
        "210G LC": { flowMin:35,flowMax:52,psiMax:4350,capacity:47000,coupler:"Pin-On" },
        "250G LC": { flowMin:40,flowMax:60,psiMax:4350,capacity:57000,coupler:"Pin-On" },
        "290G LC": { flowMin:48,flowMax:72,psiMax:4700,capacity:68000,coupler:"Pin-On" },
        "345G LC": { flowMin:55,flowMax:82,psiMax:4700,capacity:78000,coupler:"Pin-On" },
        "380G LC": { flowMin:62,flowMax:91,psiMax:5076,capacity:90000,coupler:"Pin-On" },
        "470G LC": { flowMin:76,flowMax:112,psiMax:5076,capacity:105000,coupler:"Pin-On" }
      },
      "Doosan": {
        "DX140LC-7": { flowMin:28,flowMax:42,psiMax:4500,capacity:32000,coupler:"Pin-On" },
        "DX225LC-7": { flowMin:40,flowMax:60,psiMax:4500,capacity:53000,coupler:"Pin-On" },
        "DX300LC-7": { flowMin:52,flowMax:78,psiMax:4700,capacity:72000,coupler:"Pin-On" },
        "DX380LC-7": { flowMin:64,flowMax:95,psiMax:5076,capacity:86000,coupler:"Pin-On" },
        "DX490LC-7": { flowMin:80,flowMax:118,psiMax:5076,capacity:110000,coupler:"Pin-On" }
      },
      "Volvo": {
        "ECR145E": { flowMin:28,flowMax:42,psiMax:4350,capacity:32000,coupler:"Pin-On" },
        "EC220E":  { flowMin:38,flowMax:56,psiMax:4350,capacity:50000,coupler:"Pin-On" },
        "EC300E":  { flowMin:50,flowMax:74,psiMax:4700,capacity:70000,coupler:"Pin-On" },
        "EC380E":  { flowMin:63,flowMax:93,psiMax:5076,capacity:87000,coupler:"Pin-On" },
        "EC480E":  { flowMin:80,flowMax:118,psiMax:5076,capacity:110000,coupler:"Pin-On" }
      },
      "Hitachi": {
        "ZX130-6":     { flowMin:22,flowMax:30,psiMax:4785,capacity:29000,coupler:"Pin-On" },
        "ZX210LC-6":   { flowMin:33,flowMax:50,psiMax:4930,capacity:48000,coupler:"Pin-On" },
        "ZX250LC-6":   { flowMin:40,flowMax:58,psiMax:4930,capacity:58000,coupler:"Pin-On" },
        "ZX350LC-6":   { flowMin:57,flowMax:84,psiMax:5076,capacity:80000,coupler:"Pin-On" },
        "ZX470LC-6":   { flowMin:74,flowMax:110,psiMax:5076,capacity:107000,coupler:"Pin-On" }
      },
      "Kobelco": {
        "SK140SRLC-7": { flowMin:24,flowMax:36,psiMax:4728,capacity:31000,coupler:"Pin-On" },
        "SK210LC-11":  { flowMin:36,flowMax:53,psiMax:5076,capacity:48000,coupler:"Pin-On" },
        "SK300LC-11":  { flowMin:51,flowMax:77,psiMax:5076,capacity:70000,coupler:"Pin-On" },
        "SK500LC-11":  { flowMin:80,flowMax:118,psiMax:5076,capacity:112000,coupler:"Pin-On" }
      },
      "Link-Belt": {
        "145 X4": { flowMin:24,flowMax:36,psiMax:4930,capacity:32000,coupler:"Pin-On",note:"Manufactured in Lexington, KY." },
        "210 X4": { flowMin:35,flowMax:53,psiMax:4930,capacity:48000,coupler:"Pin-On",note:"Manufactured in Lexington, KY." },
        "300 X4": { flowMin:50,flowMax:75,psiMax:5076,capacity:70000,coupler:"Pin-On",note:"Manufactured in Lexington, KY." },
        "350 X4": { flowMin:57,flowMax:85,psiMax:5076,capacity:82000,coupler:"Pin-On",note:"Manufactured in Lexington, KY." }
      },
      "Sany": {
        "SY135C": { flowMin:23,flowMax:34,psiMax:5076,capacity:30000,coupler:"Pin-On" },
        "SY215C": { flowMin:37,flowMax:55,psiMax:5076,capacity:49000,coupler:"Pin-On" },
        "SY265C": { flowMin:43,flowMax:65,psiMax:5076,capacity:61000,coupler:"Pin-On" },
        "SY305H": { flowMin:51,flowMax:75,psiMax:5076,capacity:70000,coupler:"Pin-On" }
      },
      "JCB": {
        "JS131": { flowMin:23,flowMax:34,psiMax:4990,capacity:29000,coupler:"Pin-On" },
        "JS205": { flowMin:36,flowMax:54,psiMax:4990,capacity:48000,coupler:"Pin-On" },
        "JS260": { flowMin:43,flowMax:65,psiMax:4990,capacity:61000,coupler:"Pin-On" },
        "JS370": { flowMin:62,flowMax:90,psiMax:4990,capacity:85000,coupler:"Pin-On" }
      }
    }
  },

  // ═══════════════════════════════════════════════════════
  //  MINI EXCAVATORS (under ~20,000 lbs)
  // ═══════════════════════════════════════════════════════
  "mini-excavator": {
    supportsHighFlow: false,
    makes: {
      "Kubota": {
        "K008-5":  { flowMin:4.5,flowMax:4.5,psiMax:2200,capacity:2000,coupler:"Kubota K-Series" },
        "KX018-4": { flowMin:7.4,flowMax:7.4,psiMax:2500,capacity:3750,coupler:"Kubota K-Series" },
        "U17-5":   { flowMin:7.0,flowMax:7.0,psiMax:2562,capacity:3750,coupler:"Kubota K-Series" },
        "KX033-4": { flowMin:10.2,flowMax:10.2,psiMax:2844,capacity:7540,coupler:"Kubota K-Series" },
        "U27-4":   { flowMin:11.0,flowMax:11.0,psiMax:2844,capacity:5900,coupler:"Kubota K-Series" },
        "KX040-5": { flowMin:14.3,flowMax:14.3,psiMax:2844,capacity:9500,coupler:"Kubota K-Series" },
        "U35-4":   { flowMin:12.0,flowMax:12.0,psiMax:2844,capacity:8300,coupler:"Kubota K-Series" },
        "KX057-5": { flowMin:18.0,flowMax:18.0,psiMax:2844,capacity:12340,coupler:"Kubota K-Series" },
        "U55-5":   { flowMin:18.0,flowMax:18.0,psiMax:2844,capacity:12000,coupler:"Kubota K-Series" },
        "KX080-5": { flowMin:26.0,flowMax:26.0,psiMax:3100,capacity:18500,coupler:"Kubota K-Series" }
      },
      "Bobcat": {
        "E10": { flowMin:4.0,flowMax:4.0,psiMax:2030,capacity:2000,coupler:"Pin-On" },
        "E20": { flowMin:9.0,flowMax:9.0,psiMax:2800,capacity:4000,coupler:"Pin-On" },
        "E32": { flowMin:14.0,flowMax:14.0,psiMax:2960,capacity:7400,coupler:"Pin-On" },
        "E35": { flowMin:14.0,flowMax:14.0,psiMax:2960,capacity:7900,coupler:"Pin-On" },
        "E50": { flowMin:18.0,flowMax:18.0,psiMax:3200,capacity:11200,coupler:"Pin-On" },
        "E55": { flowMin:18.0,flowMax:18.0,psiMax:3200,capacity:12500,coupler:"Pin-On" },
        "E60": { flowMin:22.0,flowMax:22.0,psiMax:3200,capacity:13800,coupler:"Pin-On" },
        "E85": { flowMin:22.0,flowMax:22.0,psiMax:3200,capacity:18700,coupler:"Pin-On" },
        "E88": { flowMin:22.0,flowMax:22.0,psiMax:3200,capacity:19600,coupler:"Pin-On" }
      },
      "John Deere": {
        "17G":  { flowMin:6.3,flowMax:6.3,psiMax:2465,capacity:3500,coupler:"Pin-On" },
        "26G":  { flowMin:9.5,flowMax:9.5,psiMax:2900,capacity:5700,coupler:"Pin-On" },
        "35G":  { flowMin:13.0,flowMax:13.0,psiMax:2900,capacity:7500,coupler:"Pin-On" },
        "50G":  { flowMin:16.0,flowMax:16.0,psiMax:3000,capacity:11000,coupler:"Pin-On" },
        "60G":  { flowMin:20.0,flowMax:20.0,psiMax:3200,capacity:13000,coupler:"Pin-On" },
        "75G":  { flowMin:22.0,flowMax:22.0,psiMax:3200,capacity:17000,coupler:"Pin-On" },
        "85G":  { flowMin:26.0,flowMax:26.0,psiMax:3200,capacity:19000,coupler:"Pin-On" }
      },
      "Caterpillar": {
        "301.7 CR": { flowMin:8.0,flowMax:8.0,psiMax:2820,capacity:3700,coupler:"CAT Pin-On" },
        "303 CR":   { flowMin:11.0,flowMax:11.0,psiMax:3000,capacity:6000,coupler:"CAT Pin-On" },
        "304 CR":   { flowMin:11.8,flowMax:11.8,psiMax:3000,capacity:7500,coupler:"CAT Pin-On" },
        "305 CR":   { flowMin:13.0,flowMax:13.0,psiMax:3120,capacity:10200,coupler:"CAT Pin-On" },
        "306 CR":   { flowMin:15.0,flowMax:15.0,psiMax:3120,capacity:13000,coupler:"CAT Pin-On" },
        "307 CR":   { flowMin:20.0,flowMax:20.0,psiMax:3200,capacity:16000,coupler:"CAT Pin-On" },
        "308 CR":   { flowMin:22.0,flowMax:22.0,psiMax:3200,capacity:18500,coupler:"CAT Pin-On" }
      },
      "Takeuchi": {
        "TB216":   { flowMin:7.5,flowMax:7.5,psiMax:2560,capacity:3600,coupler:"Pin-On" },
        "TB230":   { flowMin:11.0,flowMax:11.0,psiMax:2900,capacity:6700,coupler:"Pin-On" },
        "TB235":   { flowMin:13.0,flowMax:13.0,psiMax:2900,capacity:7900,coupler:"Pin-On" },
        "TB250-2": { flowMin:16.5,flowMax:16.5,psiMax:3560,capacity:11700,coupler:"Pin-On" },
        "TB260":   { flowMin:20.0,flowMax:20.0,psiMax:3560,capacity:13700,coupler:"Pin-On" },
        "TB285":   { flowMin:24.0,flowMax:24.0,psiMax:3560,capacity:19200,coupler:"Pin-On" }
      },
      "Yanmar": {
        "SV17":  { flowMin:6.9,flowMax:6.9,psiMax:2345,capacity:3600,coupler:"Pin-On" },
        "SV26":  { flowMin:9.0,flowMax:9.0,psiMax:2560,capacity:5800,coupler:"Pin-On" },
        "SV40":  { flowMin:14.0,flowMax:14.0,psiMax:2900,capacity:9000,coupler:"Pin-On" },
        "SV57":  { flowMin:17.0,flowMax:17.0,psiMax:3000,capacity:12700,coupler:"Pin-On" },
        "SV80":  { flowMin:24.0,flowMax:24.0,psiMax:3000,capacity:18000,coupler:"Pin-On" }
      },
      "Doosan": {
        "DX27Z-7": { flowMin:9.0,flowMax:9.0,psiMax:2900,capacity:5800,coupler:"Pin-On" },
        "DX35Z-7": { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:7700,coupler:"Pin-On" },
        "DX42-7":  { flowMin:14.0,flowMax:14.0,psiMax:2900,capacity:9400,coupler:"Pin-On" },
        "DX62R-7": { flowMin:20.0,flowMax:20.0,psiMax:3200,capacity:14600,coupler:"Pin-On" },
        "DX85R-7": { flowMin:24.0,flowMax:24.0,psiMax:3200,capacity:19000,coupler:"Pin-On" }
      },
      "Volvo": {
        "ECR25D": { flowMin:9.0,flowMax:9.0,psiMax:2900,capacity:5700,coupler:"Pin-On" },
        "ECR35D": { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:8000,coupler:"Pin-On" },
        "ECR50D": { flowMin:16.0,flowMax:16.0,psiMax:3100,capacity:11500,coupler:"Pin-On" },
        "ECR88D": { flowMin:24.0,flowMax:24.0,psiMax:3200,capacity:20000,coupler:"Pin-On" }
      },
      "Hyundai": {
        "HX17A": { flowMin:6.2,flowMax:6.2,psiMax:2562,capacity:3600,coupler:"Pin-On" },
        "HX35A": { flowMin:12.0,flowMax:12.0,psiMax:2900,capacity:8000,coupler:"Pin-On" },
        "HX55A": { flowMin:17.5,flowMax:17.5,psiMax:3000,capacity:12500,coupler:"Pin-On" },
        "HX85A": { flowMin:24.0,flowMax:24.0,psiMax:3200,capacity:19000,coupler:"Pin-On" }
      },
      "Komatsu": {
        "PC26MR-5":  { flowMin:9.5,flowMax:9.5,psiMax:2900,capacity:5900,coupler:"Pin-On" },
        "PC35MR-5":  { flowMin:12.5,flowMax:12.5,psiMax:2900,capacity:8000,coupler:"Pin-On" },
        "PC55MR-5":  { flowMin:17.5,flowMax:17.5,psiMax:3000,capacity:12500,coupler:"Pin-On" },
        "PC78MR-11": { flowMin:23.0,flowMax:23.0,psiMax:3200,capacity:17500,coupler:"Pin-On" },
        "PC88MR-11": { flowMin:26.0,flowMax:26.0,psiMax:3200,capacity:20000,coupler:"Pin-On" }
      },
      "Sany Mini": {
        "SY16C": { flowMin:4.8,flowMax:7.5,psiMax:2611,capacity:3600,coupler:"Pin-On" },
        "SY26U": { flowMin:6.8,flowMax:10.5,psiMax:2611,capacity:5700,coupler:"Pin-On" },
        "SY35U": { flowMin:8.8,flowMax:13.5,psiMax:2900,capacity:7800,coupler:"Pin-On" },
        "SY55C": { flowMin:13.5,flowMax:21.0,psiMax:3263,capacity:12200,coupler:"Pin-On" },
        "SY75C": { flowMin:18.0,flowMax:28.0,psiMax:3480,capacity:17000,coupler:"Pin-On" }
      }
    }
  },

  // ═══════════════════════════════════════════════════════
  //  LOADERS (compact wheel loaders)
  // ═══════════════════════════════════════════════════════
  "loader": {
    supportsHighFlow: false,
    makes: {
      "John Deere": {
        "244K": { flowMin:18,flowMax:25,psiMax:3000,capacity:5500,coupler:"Deere Quik-Tatch" },
        "324K": { flowMin:22,flowMax:32,psiMax:3000,capacity:7500,coupler:"Deere Quik-Tatch" },
        "444K": { flowMin:28,flowMax:40,psiMax:3200,capacity:12000,coupler:"Deere Quik-Tatch" },
        "544L": { flowMin:35,flowMax:50,psiMax:3700,capacity:16500,coupler:"Deere Quik-Tatch" },
        "644K": { flowMin:42,flowMax:62,psiMax:3700,capacity:25000,coupler:"Deere Quik-Tatch" }
      },
      "Caterpillar": {
        "906M": { flowMin:16,flowMax:24,psiMax:3000,capacity:5300,coupler:"Universal" },
        "910M": { flowMin:22,flowMax:32,psiMax:3200,capacity:8000,coupler:"Universal" },
        "926M": { flowMin:30,flowMax:44,psiMax:3500,capacity:12500,coupler:"Cat IT" },
        "938M": { flowMin:35,flowMax:52,psiMax:3700,capacity:16000,coupler:"Cat IT" },
        "950M": { flowMin:40,flowMax:58,psiMax:3800,capacity:17500,coupler:"Cat IT" },
        "966M": { flowMin:52,flowMax:76,psiMax:4000,capacity:25000,coupler:"Cat IT" }
      },
      "Komatsu": {
        "WA100M-8":  { flowMin:20,flowMax:30,psiMax:3000,capacity:7700,coupler:"Universal" },
        "WA200-8":   { flowMin:30,flowMax:44,psiMax:3200,capacity:13200,coupler:"Universal" },
        "WA320PZ-6": { flowMin:42,flowMax:60,psiMax:3700,capacity:18000,coupler:"Universal" },
        "WA380-8":   { flowMin:48,flowMax:70,psiMax:3700,capacity:22000,coupler:"Universal" }
      },
      "Case": {
        "621G":  { flowMin:30,flowMax:44,psiMax:3200,capacity:12500,coupler:"Universal Skid Steer (SSL)" },
        "721G":  { flowMin:34,flowMax:50,psiMax:3300,capacity:15500,coupler:"Universal Skid Steer (SSL)" },
        "821G":  { flowMin:42,flowMax:62,psiMax:3600,capacity:20000,coupler:"Universal Skid Steer (SSL)" },
        "921G":  { flowMin:52,flowMax:76,psiMax:3900,capacity:26000,coupler:"Universal Skid Steer (SSL)" }
      },
      "Volvo": {
        "L25H":  { flowMin:14,flowMax:20,psiMax:2900,capacity:4400,coupler:"Universal" },
        "L60H":  { flowMin:30,flowMax:44,psiMax:3200,capacity:13000,coupler:"Universal" },
        "L90H":  { flowMin:42,flowMax:62,psiMax:3700,capacity:19000,coupler:"Universal" },
        "L120H": { flowMin:56,flowMax:82,psiMax:3700,capacity:27500,coupler:"Universal" }
      }
    }
  },

  // ═══════════════════════════════════════════════════════
  //  TRACTORS
  // ═══════════════════════════════════════════════════════
  "tractor": {
    supportsHighFlow: false,
    makes: {
      "John Deere": {
        "1025R": { auxFlowMin:3.5,auxFlowMax:3.5,psiMax:2000,engineHP:24,ptoHP:18,note:"Sub-compact. Aux pump 3.5 GPM." },
        "2038R": { auxFlowMin:5.3,auxFlowMax:5.3,psiMax:2500,engineHP:37,ptoHP:28,note:"Compact utility." },
        "3046R": { auxFlowMin:8.6,auxFlowMax:8.6,psiMax:2610,engineHP:46,ptoHP:36,note:"R-series compact." },
        "4066R": { auxFlowMin:10.2,auxFlowMax:10.2,psiMax:2500,engineHP:66,ptoHP:53,note:"Top compact utility. Up to 5 SCVs." },
        "5100E": { auxFlowMin:11.4,auxFlowMax:11.4,psiMax:2828,engineHP:100,ptoHP:84,note:"Utility tractor." },
        "5115M": { auxFlowMin:17.4,auxFlowMax:17.4,psiMax:2755,engineHP:115,ptoHP:97,note:"Mid-spec utility. Optional 24.9 GPM pump." },
        "6175R": { auxFlowMin:27.0,auxFlowMax:40.0,psiMax:2900,engineHP:175,ptoHP:152,note:"Row crop." },
        "6250R": { auxFlowMin:35.0,auxFlowMax:46.0,psiMax:2900,engineHP:250,ptoHP:218,note:"High-horsepower row crop." },
        "7310R": { auxFlowMin:40.0,auxFlowMax:66.0,psiMax:2990,engineHP:310,ptoHP:270,note:"Large row crop." },
        "8R 370": { auxFlowMin:46.0,auxFlowMax:78.0,psiMax:3190,engineHP:370,ptoHP:316,note:"High-hp row crop." }
      },
      "Kubota": {
        "BX2380": { auxFlowMin:3.5,auxFlowMax:3.5,psiMax:1991,engineHP:23,ptoHP:17,note:"Sub-compact. 3.5 GPM aux." },
        "L3902":  { auxFlowMin:6.3,auxFlowMax:6.3,psiMax:2347,engineHP:38,ptoHP:32,note:"Standard L-Series." },
        "L4702":  { auxFlowMin:9.1,auxFlowMax:9.1,psiMax:2418,engineHP:47,ptoHP:38,note:"Standard L-Series. Larger aux pump." },
        "MX6000": { auxFlowMin:14.0,auxFlowMax:14.0,psiMax:2560,engineHP:60,ptoHP:52,note:"Mid-frame utility." },
        "M5-111": { auxFlowMin:16.7,auxFlowMax:16.7,psiMax:2560,engineHP:111,ptoHP:96,note:"Utility." },
        "M7-191": { auxFlowMin:26.4,auxFlowMax:39.6,psiMax:2900,engineHP:191,ptoHP:166,note:"Row crop." }
      },
      "Case IH": {
        "Farmall 35B":  { auxFlowMin:5.5,auxFlowMax:5.5,psiMax:2200,engineHP:37,ptoHP:29,note:"Sub-compact." },
        "Farmall 75A":  { auxFlowMin:12.4,auxFlowMax:12.4,psiMax:2650,engineHP:74,ptoHP:64,note:"Small utility." },
        "Farmall 100C": { auxFlowMin:16.4,auxFlowMax:21.7,psiMax:2700,engineHP:100,ptoHP:87,note:"Medium utility." },
        "Maxxum 145":   { auxFlowMin:22.7,auxFlowMax:39.6,psiMax:2900,engineHP:145,ptoHP:125,note:"Opt 39.6 GPM PFC on CVX models." },
        "Magnum 280":   { auxFlowMin:36.6,auxFlowMax:86.0,psiMax:3045,engineHP:280,ptoHP:240,note:"Row crop. Up to 86 GPM available." },
        "Magnum 400":   { auxFlowMin:36.6,auxFlowMax:86.0,psiMax:3045,engineHP:400,ptoHP:341,note:"Row crop." }
      },
      "New Holland": {
        "Workmaster 25S": { auxFlowMin:3.5,auxFlowMax:3.5,psiMax:1813,engineHP:25,ptoHP:18,note:"Sub-compact." },
        "T4.105 PowerStar": { auxFlowMin:12.5,auxFlowMax:16.9,psiMax:2650,engineHP:105,ptoHP:88,note:"Std 12.5 GPM; opt 16.9 GPM." },
        "T6.175":          { auxFlowMin:22.2,auxFlowMax:39.6,psiMax:2900,engineHP:175,ptoHP:152,note:"Utility/row crop." },
        "T7.290":          { auxFlowMin:35.2,auxFlowMax:66.0,psiMax:3045,engineHP:290,ptoHP:253,note:"Row crop." },
        "T8.410":          { auxFlowMin:52.8,auxFlowMax:79.2,psiMax:3190,engineHP:410,ptoHP:357,note:"High-hp." }
      },
      "Massey Ferguson": {
        "MF 1742":   { auxFlowMin:6.3,auxFlowMax:6.3,psiMax:2200,engineHP:42,ptoHP:34,note:"Premium compact." },
        "MF 5S.145": { auxFlowMin:22.2,auxFlowMax:30.0,psiMax:2900,engineHP:145,ptoHP:126,note:"Mid-utility." },
        "MF 7S.195": { auxFlowMin:28.7,auxFlowMax:50.0,psiMax:2900,engineHP:195,ptoHP:170,note:"High utility." },
        "MF 8S.305": { auxFlowMin:39.6,auxFlowMax:66.0,psiMax:3045,engineHP:305,ptoHP:264,note:"Large row crop." }
      },
      "Mahindra": {
        "eMax 25":  { auxFlowMin:4.0,auxFlowMax:5.5,psiMax:1885,engineHP:25,ptoHP:18,note:"Sub-compact." },
        "2638":     { auxFlowMin:7.0,auxFlowMax:10.0,psiMax:2176,engineHP:38,ptoHP:29,note:"Utility." },
        "6060":     { auxFlowMin:11.5,auxFlowMax:16.5,psiMax:2465,engineHP:60,ptoHP:47,note:"Mid-utility." },
        "8090":     { auxFlowMin:16.0,auxFlowMax:22.5,psiMax:2610,engineHP:90,ptoHP:74,note:"Mid-utility." }
      },
      "Kioti": {
        "CS2610":  { auxFlowMin:3.5,auxFlowMax:5.5,psiMax:1885,engineHP:25.5,ptoHP:19,note:"Sub-compact." },
        "CK4010":  { auxFlowMin:6.5,auxFlowMax:9.5,psiMax:2176,engineHP:39.5,ptoHP:31,note:"Compact." },
        "DK5510":  { auxFlowMin:9.5,auxFlowMax:13.5,psiMax:2320,engineHP:55,ptoHP:44,note:"Mid-utility." },
        "NX6510":  { auxFlowMin:12.0,auxFlowMax:17.0,psiMax:2610,engineHP:65,ptoHP:52,note:"Utility." },
        "PX1053":  { auxFlowMin:17.0,auxFlowMax:24.0,psiMax:2755,engineHP:105,ptoHP:87,note:"Mid-size utility." }
      }
    }
  }
};


/* ══════════════════════════════════════════════════════════
   SPEC PARSER — Extracts specs from product description HTML
   ══════════════════════════════════════════════════════════ */
function parseSpecs(raw) {
  var t = raw.replace(/<[^>]+>/g,'').replace(/,/g,'').replace(/&amp;/g,'&').replace(/&#39;/g,"'");
  var s = { flowMin:null, flowMax:null, psiMax:null, weight:null, coupler:null };

  // Flow (GPM)
  var fr = t.match(/(\d+\.?\d*)\s*[-–to]+\s*(\d+\.?\d*)\s*GPM/i);
  var fs = t.match(/(\d+\.?\d*)\s*GPM/i);
  if (fr) { s.flowMin = parseFloat(fr[1]); s.flowMax = parseFloat(fr[2]); }
  else if (fs) { s.flowMin = s.flowMax = parseFloat(fs[1]); }

  // PSI — take highest value
  var pm = t.match(/(\d+\.?\d*)\s*PSI/gi);
  if (pm) {
    var vals = [];
    for (var i = 0; i < pm.length; i++) {
      var m = pm[i].match(/(\d+\.?\d*)/);
      if (m) vals.push(parseFloat(m[1]));
    }
    if (vals.length) s.psiMax = Math.max.apply(null, vals);
  }

  // Weight
  var wm = t.match(/(\d+\.?\d*)\s*(?:lbs?|pounds?)\b/i);
  if (wm) s.weight = parseFloat(wm[1]);

  // Coupler
  var couplers = [
    ['Bob-Tach',                   /bob.?tach/i],
    ['Universal Skid Steer (SSL)', /universal\s*(skid\s*steer|ssl)/i],
    ['Deere Quik-Tatch',           /quik.?tatch|deere\s*quick/i],
    ['Cat IT',                     /cat\s*it\b/i],
    ['Kubota K-Series',            /kubota\s*k.series/i],
    ['Mini SSL',                   /mini\s*ssl/i],
    ['CAT Pin-On',                 /cat\s*pin.?on/i],
    ['Pin-On',                     /\bpin.?on\b/i],
    ['Universal',                  /\buniversal\b/i]
  ];
  for (var c = 0; c < couplers.length; c++) {
    if (couplers[c][1].test(t)) { s.coupler = couplers[c][0]; break; }
  }
  return s;
}


/* ══════════════════════════════════════════════════════════
   COUPLER COMPATIBILITY
   ══════════════════════════════════════════════════════════ */
function couplerCompat(att, mach) {
  if (!att || !mach) return 'unknown';
  if (att === mach) return 'ok';
  if (att === 'Universal' || mach === 'Universal') return 'ok';
  if (att === 'Universal Skid Steer (SSL)') return 'ok';
  var ssl = ['Bob-Tach','Universal Skid Steer (SSL)','Deere Quik-Tatch','Cat IT','Kubota K-Series','New Holland'];
  if (ssl.indexOf(att) !== -1 && ssl.indexOf(mach) !== -1) return 'adapter';
  return 'fail';
}


/* ══════════════════════════════════════════════════════════
   STATE
   ══════════════════════════════════════════════════════════ */
var STATE = {
  machineType: null,
  machineSpecs: null,
  flowMode: 'standard',
  attSpecs: null,
  machineName: ''
};


/* ══════════════════════════════════════════════════════════
   CHIP STRIP UPDATE
   ══════════════════════════════════════════════════════════ */
function updateParsedStrip() {
  var s = STATE.attSpecs;
  if (!s) return;
  var fv = s.flowMin && s.flowMax
    ? (s.flowMin === s.flowMax ? s.flowMin : s.flowMin + '–' + s.flowMax)
    : '?';
  document.getElementById('chip-flow-val').textContent = fv;
  document.getElementById('chip-psi-val').textContent  = s.psiMax ? s.psiMax.toLocaleString() : '?';
  document.getElementById('chip-weight-val').textContent = s.weight ? s.weight.toLocaleString() : '?';
  document.getElementById('chip-coupler-val').textContent = s.coupler || '?';
}


/* ══════════════════════════════════════════════════════════
   SELECT MACHINE TYPE
   ══════════════════════════════════════════════════════════ */
function selectType(btn) {
  var btns = document.querySelectorAll('.sw-type');
  for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
  btn.classList.add('active');
  STATE.machineType = btn.dataset.type;
  STATE.flowMode = 'standard';

  document.getElementById('sw-machine-preview').classList.remove('visible');
  document.getElementById('sw-check-btn').disabled = true;
  document.getElementById('sw-results').classList.remove('visible');

  var makeEl  = document.getElementById('sw-make');
  var modelEl = document.getElementById('sw-model');
  makeEl.innerHTML  = '<option value="">— Select Make —</option>';
  modelEl.innerHTML = '<option value="">— Select Model —</option>';

  var typeData = MACHINES[STATE.machineType];
  if (!typeData) return;
  var makes = Object.keys(typeData.makes);
  for (var j = 0; j < makes.length; j++) {
    var o = document.createElement('option');
    o.value = makes[j]; o.textContent = makes[j];
    makeEl.appendChild(o);
  }

  document.getElementById('sw-selects').classList.remove('locked');

  var toggle = document.getElementById('sw-flow-toggle');
  if (typeData.supportsHighFlow) toggle.classList.add('visible');
  else toggle.classList.remove('visible');

  var flowOpts = document.querySelectorAll('.sw-flow-opt');
  for (var k = 0; k < flowOpts.length; k++) flowOpts[k].classList.remove('active');
  document.querySelector('.sw-flow-opt[data-flow="standard"]').classList.add('active');
  document.getElementById('std-flow-gpms').textContent = '—';
  document.getElementById('hf-flow-gpms').textContent  = '—';
  document.getElementById('sw-flow-badge').classList.remove('visible');
}


/* ══════════════════════════════════════════════════════════
   HIGH-FLOW TOGGLE
   ══════════════════════════════════════════════════════════ */
function selectFlowType(el) {
  var opts = document.querySelectorAll('.sw-flow-opt');
  for (var i = 0; i < opts.length; i++) opts[i].classList.remove('active');
  el.classList.add('active');
  STATE.flowMode = el.dataset.flow;
  if (STATE.machineSpecs) renderMachinePreview();
  updateFlowBadge();
}

function updateFlowBadge() {
  var badge = document.getElementById('sw-flow-badge');
  var text  = document.getElementById('sw-flow-badge-text');
  if (STATE.machineSpecs) {
    badge.classList.add('visible');
    if (STATE.machineType === 'tractor') {
      var s = STATE.machineSpecs;
      var flow = s.auxFlowMin === s.auxFlowMax ? s.auxFlowMin : s.auxFlowMin + '–' + s.auxFlowMax;
      text.textContent = 'Aux flow \u2014 ' + flow + ' GPM';
    } else {
      var isHF = STATE.flowMode === 'high' && STATE.machineSpecs.hfFlowMin;
      text.textContent = isHF
        ? 'High-flow selected \u2014 ' + STATE.machineSpecs.hfFlowMin + '–' + STATE.machineSpecs.hfFlowMax + ' GPM'
        : 'Standard flow \u2014 ' + STATE.machineSpecs.flowMin + '–' + STATE.machineSpecs.flowMax + ' GPM';
    }
  } else {
    badge.classList.remove('visible');
  }
}


/* ══════════════════════════════════════════════════════════
   UPDATE MODELS DROPDOWN
   ══════════════════════════════════════════════════════════ */
function updateModels() {
  var make   = document.getElementById('sw-make').value;
  var modelEl = document.getElementById('sw-model');
  modelEl.innerHTML = '<option value="">— Select Model —</option>';
  document.getElementById('sw-machine-preview').classList.remove('visible');
  document.getElementById('sw-check-btn').disabled = true;
  document.getElementById('sw-flow-badge').classList.remove('visible');
  if (!make || !STATE.machineType) return;

  var typeData = MACHINES[STATE.machineType];
  var models = Object.keys(typeData.makes[make] || {});
  for (var i = 0; i < models.length; i++) {
    var o = document.createElement('option');
    o.value = models[i]; o.textContent = models[i];
    modelEl.appendChild(o);
  }
}


/* ══════════════════════════════════════════════════════════
   MACHINE PREVIEW
   ══════════════════════════════════════════════════════════ */
function updateMachinePreview() {
  var make  = document.getElementById('sw-make').value;
  var model = document.getElementById('sw-model').value;
  if (!make || !model || !STATE.machineType) return;

  var specs = MACHINES[STATE.machineType].makes[make] && MACHINES[STATE.machineType].makes[make][model];
  if (!specs) return;
  STATE.machineSpecs = specs;
  STATE.machineName  = make + ' ' + model;

  if (STATE.machineType === 'tractor') {
    renderMachinePreview();
    document.getElementById('sw-check-btn').disabled = false;
    document.getElementById('sw-results').classList.remove('visible');
    updateFlowBadge();
    return;
  }

  document.getElementById('std-flow-gpms').textContent = specs.flowMin + '–' + specs.flowMax + ' GPM';
  if (specs.hfFlowMin) {
    document.getElementById('hf-flow-gpms').textContent = specs.hfFlowMin + '–' + specs.hfFlowMax + ' GPM';
    document.querySelector('.sw-flow-opt[data-flow="high"]').style.opacity = '1';
    document.querySelector('.sw-flow-opt[data-flow="high"]').style.pointerEvents = '';
  } else {
    document.getElementById('hf-flow-gpms').textContent = 'Not available';
    var hfOpt = document.querySelector('.sw-flow-opt[data-flow="high"]');
    hfOpt.style.opacity = '0.45';
    hfOpt.style.pointerEvents = 'none';
    hfOpt.classList.remove('active');
    document.querySelector('.sw-flow-opt[data-flow="standard"]').classList.add('active');
    STATE.flowMode = 'standard';
  }

  renderMachinePreview();
  document.getElementById('sw-check-btn').disabled = false;
  document.getElementById('sw-results').classList.remove('visible');
  updateFlowBadge();
}

function renderMachinePreview() {
  var specs = STATE.machineSpecs;
  var titleEl = document.getElementById('sw-preview-title');
  var chipsEl = document.getElementById('sw-preview-chips');

  if (STATE.machineType === 'tractor') {
    var auxFlow = specs.auxFlowMin === specs.auxFlowMax
      ? specs.auxFlowMin + ' GPM'
      : specs.auxFlowMin + '–' + specs.auxFlowMax + ' GPM';
    titleEl.textContent = STATE.machineName;
    var pairs = [
      ['Aux Flow', auxFlow],
      ['Max PSI', specs.psiMax ? specs.psiMax.toLocaleString() + ' PSI' : 'N/A'],
      ['Engine HP', specs.engineHP ? specs.engineHP + ' hp' : 'N/A'],
      ['PTO HP', specs.ptoHP ? specs.ptoHP + ' hp' : 'N/A']
    ];
    chipsEl.innerHTML = pairs.map(function(p) {
      return '<div class="sw-mc-chip">' + p[0] + ': <span>' + p[1] + '</span></div>';
    }).join('');
    if (specs.note) {
      chipsEl.innerHTML += '<div class="sw-mc-chip" style="font-size:0.78rem;color:#888;">\u2139\uFE0F ' + specs.note + '</div>';
    }
    document.getElementById('sw-machine-preview').classList.add('visible');
    return;
  }

  var isHF = STATE.flowMode === 'high' && specs.hfFlowMin;
  var gpms = isHF ? specs.hfFlowMin + '–' + specs.hfFlowMax : specs.flowMin + '–' + specs.flowMax;

  titleEl.textContent = STATE.machineName + (isHF ? ' (High Flow)' : '');
  var pairs2 = [
    ['Flow', gpms + ' GPM' + (isHF ? ' \u26A1' : '')],
    ['Max PSI', specs.psiMax ? specs.psiMax.toLocaleString() : 'N/A'],
    ['Op. Cap.', specs.capacity ? specs.capacity.toLocaleString() + ' lbs' : 'N/A'],
    ['Coupler', specs.coupler]
  ];
  chipsEl.innerHTML = pairs2.map(function(p) {
    return '<div class="sw-mc-chip">' + p[0] + ': <span>' + p[1] + '</span></div>';
  }).join('');
  document.getElementById('sw-machine-preview').classList.add('visible');
}


/* ══════════════════════════════════════════════════════════
   RUN COMPATIBILITY CHECK
   ══════════════════════════════════════════════════════════ */
function runCheck() {
  var ms = STATE.machineSpecs;
  var as = STATE.attSpecs;

  var rows  = [];
  var notes = [];
  var fails = 0, warns = 0;

  /* ── TRACTOR BRANCH ──────────────────────────────────── */
  if (STATE.machineType === 'tractor') {
    var machFlowMin = ms.auxFlowMin;
    var machFlowMax = ms.auxFlowMax;

    if (as.flowMin !== null || as.flowMax !== null) {
      var attMin = as.flowMin, attMax = as.flowMax;
      var mHave = machFlowMin + '–' + machFlowMax + ' GPM (aux)';
      var aNeed = (attMin || '?') + (attMax && attMax !== attMin ? '–' + attMax : '') + ' GPM';
      var s = 'ok';
      if (attMin && attMin > machFlowMax) {
        s = 'fail'; fails++;
        notes.push('Attachment requires at least ' + attMin + ' GPM. Tractor aux max is ' + machFlowMax + ' GPM. Insufficient flow.');
      } else if (attMax && attMax > machFlowMax) {
        s = 'warn'; warns++;
        notes.push('Attachment can use up to ' + attMax + ' GPM; tractor aux max is ' + machFlowMax + ' GPM. Reduced performance.');
      }
      rows.push({ name:'Aux Flow (GPM)', machine: mHave, att: aNeed, status: s });
    }

    if (as.psiMax !== null && ms.psiMax) {
      var mHave2 = 'Up to ' + ms.psiMax.toLocaleString() + ' PSI';
      var aNeed2 = as.psiMax.toLocaleString() + ' PSI';
      var s2 = 'ok';
      if (as.psiMax > ms.psiMax * 1.05) { s2 = 'fail'; fails++; notes.push('Attachment max pressure exceeds tractor capacity.'); }
      else if (as.psiMax > ms.psiMax * 0.95) { s2 = 'warn'; warns++; notes.push('Operating near max system pressure.'); }
      rows.push({ name:'Pressure', machine: mHave2, att: aNeed2, status: s2 });
    }

    if (ms.engineHP) rows.push({ name:'Engine HP', machine: ms.engineHP + ' hp', att: '\u2014 (reference)', status: 'ok' });
    if (ms.ptoHP) rows.push({ name:'PTO HP', machine: ms.ptoHP + ' hp', att: '\u2014 (reference)', status: 'ok' });
    notes.push('\u2139\uFE0F Tractor check covers aux hydraulic flow and pressure. HP shown for reference.');

    renderVerdict(rows, notes, fails, warns);
    return;
  }

  /* ── NON-TRACTOR BRANCH ──────────────────────────────── */
  var isHF = STATE.flowMode === 'high' && ms.hfFlowMin;
  var machineFlowMin = isHF ? ms.hfFlowMin : ms.flowMin;
  var machineFlowMax = isHF ? ms.hfFlowMax : ms.flowMax;

  // Flow Rate
  if (as.flowMin !== null || as.flowMax !== null) {
    var aMin = as.flowMin, aMax = as.flowMax;
    var mH = machineFlowMin + '–' + machineFlowMax + ' GPM' + (isHF ? ' \u26A1' : '');
    var aN = (aMin || '?') + (aMax && aMax !== aMin ? '–' + aMax : '') + ' GPM';
    var st = 'ok';
    if (aMin && aMin > machineFlowMax) {
      st = 'fail'; fails++;
      notes.push('Attachment needs at least ' + aMin + ' GPM. Machine delivers max ' + machineFlowMax + ' GPM. Insufficient power.');
      if (!isHF && ms.hfFlowMin && aMin <= ms.hfFlowMax) {
        notes.push('\u26A1 High-flow upgrade may resolve this \u2014 ' + ms.hfFlowMin + '–' + ms.hfFlowMax + ' GPM.');
      }
    } else if (aMax && aMax > machineFlowMax) {
      st = 'warn'; warns++;
      notes.push('Attachment can use up to ' + aMax + ' GPM; machine max is ' + machineFlowMax + ' GPM. Reduced speed/power.');
      if (!isHF && ms.hfFlowMin && aMax <= ms.hfFlowMax) {
        notes.push('\u26A1 High-flow upgrade would allow full performance.');
      }
    }
    rows.push({ name:'Flow (GPM)', machine: mH, att: aN, status: st });
  }

  // Pressure
  if (as.psiMax !== null) {
    var mP = ms.psiMax ? 'Up to ' + ms.psiMax.toLocaleString() + ' PSI' : 'N/A';
    var aP = as.psiMax.toLocaleString() + ' PSI';
    var sp = 'ok';
    if (ms.psiMax && as.psiMax > ms.psiMax * 1.05) { sp = 'fail'; fails++; notes.push('Pressure exceeds machine capacity.'); }
    else if (ms.psiMax && as.psiMax > ms.psiMax * 0.95) { sp = 'warn'; warns++; notes.push('Pressure near machine limits. Monitor temps.'); }
    rows.push({ name:'Pressure', machine: mP, att: aP, status: sp });
  }

  // Weight
  if (as.weight && ms.capacity) {
    var pct = as.weight / ms.capacity;
    var mW = ms.capacity.toLocaleString() + ' lbs';
    var aW = as.weight.toLocaleString() + ' lbs';
    var sw = 'ok';
    if (pct > 1.0) { sw = 'fail'; fails++; notes.push('Attachment exceeds rated operating capacity. Tip-over risk.'); }
    else if (pct > 0.75) { sw = 'warn'; warns++; notes.push('Attachment is ' + Math.round(pct*100) + '% of rated capacity. Operate on level ground.'); }
    rows.push({ name:'Weight / Cap.', machine: mW, att: aW, status: sw });
  }

  // Coupler
  if (as.coupler && ms.coupler) {
    var cc = couplerCompat(as.coupler, ms.coupler);
    var sc = cc === 'ok' ? 'ok' : cc === 'adapter' ? 'warn' : 'fail';
    if (sc === 'warn') { warns++; notes.push('Coupler types differ (' + as.coupler + ' \u2192 ' + ms.coupler + '). Adapter plate may be required.'); }
    if (sc === 'fail') { fails++; notes.push('Coupler incompatible: ' + as.coupler + ' won\u2019t mount on ' + ms.coupler + '.'); }
    rows.push({ name:'Coupler', machine: ms.coupler, att: as.coupler, status: sc });
  }

  renderVerdict(rows, notes, fails, warns);
}


/* ══════════════════════════════════════════════════════════
   RENDER VERDICT & RESULTS
   ══════════════════════════════════════════════════════════ */
function renderVerdict(rows, notes, fails, warns) {
  var ms = STATE.machineSpecs;
  var as = STATE.attSpecs;
  var isHF = STATE.flowMode === 'high' && ms.hfFlowMin;

  // Verdict banner
  var verdict = document.getElementById('sw-verdict');
  verdict.className = 'sw-verdict';
  if (fails > 0) {
    verdict.classList.add('fail');
    document.getElementById('sw-verdict-title').textContent = 'Not Compatible';
    document.getElementById('sw-verdict-sub').textContent = fails + ' critical issue' + (fails>1?'s':'') + ' with your ' + STATE.machineName + '. Not recommended.';
  } else if (warns > 0) {
    verdict.classList.add('warn');
    document.getElementById('sw-verdict-title').textContent = 'Conditionally Compatible';
    document.getElementById('sw-verdict-sub').textContent = 'Check notes \u2014 some specs are at the edge of your machine\u2019s capability.';
  } else {
    verdict.classList.add('pass');
    document.getElementById('sw-verdict-title').textContent = 'Compatible';
    document.getElementById('sw-verdict-sub').textContent = 'All specs confirmed for your ' + STATE.machineName + '. Good to go.';
  }

  // Spec table
  document.getElementById('sw-spec-tbody').innerHTML = rows.map(function(r) {
    return '<tr>' +
      '<td>' + r.name + '</td>' +
      '<td>' + r.machine + '</td>' +
      '<td>' + r.att + '</td>' +
      '<td><span class="status-pill ' + r.status + '"><span class="status-dot"></span>' +
        (r.status === 'ok' ? 'Pass' : r.status === 'warn' ? 'Caution' : 'Fail') +
      '</span></td></tr>';
  }).join('');

  // Notes
  var notesEl = document.getElementById('sw-notes');
  if (notes.length > 0) {
    document.getElementById('sw-notes-list').innerHTML = notes.map(function(n) {
      return '<div class="sw-note">' + n + '</div>';
    }).join('');
    notesEl.classList.add('visible');
  } else {
    notesEl.classList.remove('visible');
  }

  // Flow comparison (non-tractors with high-flow support)
  var flowCompare = document.getElementById('sw-flow-compare');
  if (STATE.machineType !== 'tractor' && MACHINES[STATE.machineType] && MACHINES[STATE.machineType].supportsHighFlow && ms.hfFlowMin && as.flowMin) {
    flowCompare.classList.add('visible');
    var stdOk = checkFlowResult(as.flowMin, as.flowMax, ms.flowMin, ms.flowMax);
    var hfOk  = checkFlowResult(as.flowMin, as.flowMax, ms.hfFlowMin, ms.hfFlowMax);
    document.getElementById('sw-flow-compare-grid').innerHTML =
      '<div class="flow-col ' + (STATE.flowMode === 'standard' ? 'active' : '') + '">' +
        '<div class="flow-col-head">Standard Flow ' + (STATE.flowMode === 'standard' ? '<span class="current-badge">Selected</span>' : '') + '</div>' +
        '<div class="flow-col-gpms">' + ms.flowMin + '–' + ms.flowMax + ' GPM</div>' +
        '<div class="flow-col-status-wrap"><span class="status-pill ' + stdOk + '"><span class="status-dot"></span>' + (stdOk === 'ok' ? 'Pass' : stdOk === 'warn' ? 'Caution' : 'Fail') + '</span></div>' +
        '<div class="flow-col-machines">All ' + STATE.machineName + ' configs</div>' +
      '</div>' +
      '<div class="flow-col ' + (STATE.flowMode === 'high' ? 'active' : '') + '">' +
        '<div class="flow-col-head">\u26A1 High Flow ' + (STATE.flowMode === 'high' ? '<span class="current-badge">Selected</span>' : '') + '</div>' +
        '<div class="flow-col-gpms">' + ms.hfFlowMin + '–' + ms.hfFlowMax + ' GPM</div>' +
        '<div class="flow-col-status-wrap"><span class="status-pill ' + hfOk + '"><span class="status-dot"></span>' + (hfOk === 'ok' ? 'Pass' : hfOk === 'warn' ? 'Caution' : 'Fail') + '</span></div>' +
        '<div class="flow-col-machines">Requires optional high-flow kit</div>' +
      '</div>';
  } else {
    flowCompare.classList.remove('visible');
  }

  // Machine-level note
  if (ms.note) {
    document.getElementById('sw-notes-list').innerHTML += '<div class="sw-note">\u2139\uFE0F ' + ms.note + '</div>';
    document.getElementById('sw-notes').classList.add('visible');
  }

  document.getElementById('sw-results').classList.add('visible');
  document.getElementById('sw-results').scrollIntoView({ behavior:'smooth', block:'nearest' });
}

function checkFlowResult(attMin, attMax, machMin, machMax) {
  if (!attMin && !attMax) return 'ok';
  if (attMin && attMin > machMax) return 'fail';
  if (attMax && attMax > machMax) return 'warn';
  return 'ok';
}


/* ══════════════════════════════════════════════════════════
   RESET
   ══════════════════════════════════════════════════════════ */
function resetWidget() {
  var btns = document.querySelectorAll('.sw-type');
  for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
  STATE.machineType = null;
  STATE.machineSpecs = null;
  STATE.flowMode = 'standard';
  document.getElementById('sw-selects').classList.add('locked');
  document.getElementById('sw-make').innerHTML  = '<option value="">— Make —</option>';
  document.getElementById('sw-model').innerHTML = '<option value="">— Model —</option>';
  document.getElementById('sw-machine-preview').classList.remove('visible');
  document.getElementById('sw-flow-toggle').classList.remove('visible');
  document.getElementById('sw-flow-badge').classList.remove('visible');
  document.getElementById('sw-check-btn').disabled = true;
  document.getElementById('sw-results').classList.remove('visible');
  var flowOpts = document.querySelectorAll('.sw-flow-opt');
  for (var j = 0; j < flowOpts.length; j++) flowOpts[j].classList.remove('active');
  document.querySelector('.sw-flow-opt[data-flow="standard"]').classList.add('active');
}


/* ══════════════════════════════════════════════════════════
   ENTRY POINT — Called by the Liquid snippet
   initCompatWidget( product.description )
   ══════════════════════════════════════════════════════════ */
function initCompatWidget(descriptionHTML) {
  STATE.attSpecs = parseSpecs(descriptionHTML || '');
  updateParsedStrip();
}